import { TARGET_ORIGIN } from '../../config';
const configKey = 'com.moncler';
const targetOrigin = TARGET_ORIGIN;
async function initializeVykingAR({ iframe, imgFile, showLoader, hideLoader, targetPath, options, selectedAccessories, loadConfig }) {
    const { handleFeetDetection, pictureIframe, cameraIframe } = options;
    let feetDetected = false;
    function postConfig(config, clientWidth, clientHeight) {
        let cameraWidth = 360;
        let cameraHeight = 640;
        if (clientWidth > clientHeight) {
            cameraWidth = 640;
            cameraHeight = 360;
        }
        iframe.contentWindow.postMessage({
            type: 'VYKING_SNEAKER_WINDOW_CONFIG',
            config: config,
            key: configKey,
            cameraWidth: cameraWidth,
            cameraHeight: cameraHeight,
            autoPlay: true,
        }, targetOrigin);
    }
    function replaceAccessories(uri) {
        iframe.contentWindow.postMessage({
            type: 'VYKING_SNEAKER_WINDOW_REPLACE_ACCESSORIES',
            accessoryDescriptionUrl: uri,
        }, targetOrigin);
    }
    function postIframeMessage(message, transfer) {
        iframe.contentWindow.postMessage(message, targetOrigin, transfer);
    }
    function startImage() {
        showLoader();
        createImageBitmap(imgFile).then((imageBitmap) => {
            postIframeMessage({
                type: 'VYKING_SNEAKER_WINDOW_START',
                imageBitmap: imageBitmap,
            }, [imageBitmap]);
            imageBitmap.close();
        });
    }
    async function pictureMessageHandler(event) {
        const { data } = event;
        switch (data.type) {
            case 'VYKING_SNEAKER_WINDOW_WAITING_FOR_CONFIG':
                const config = await loadConfig;
                postConfig(config, window.innerWidth, window.innerHeight);
                break;
            case 'VYKING_SNEAKER_WINDOW_EXPIRY_TIME':
                console.info(`Licence expiry date: ${data.expiryTime.toString()}`);
                if (data.expiryTime.getTime() - new Date().getTime() < 1 * 24 * 60 * 60 * 1000) {
                    console.error(`Expired on ${data.expiryTime.toString()}`);
                    // fetch(configUri, {
                    //   method: 'GET',
                    //   cache: 'reload',
                    // });
                }
                break;
            case 'VYKING_SNEAKER_WINDOW_READY':
                startImage();
                break;
            case 'VYKING_SNEAKER_WINDOW_START':
                replaceAccessories(selectedAccessories);
                break;
            case 'VYKING_SNEAKER_WINDOW_FINISH':
                hideLoader();
                break;
            case 'VYKING_SNEAKER_WINDOW_REPLACE_ACCESSORY_TEXTURES':
                if (data.complete === 1) {
                    hideLoader();
                }
                break;
            case 'VYKING_SNEAKER_WINDOW_ARE_FEET_DETECTED':
                feetDetected = true;
                handleFeetDetection && handleFeetDetection(feetDetected);
                break;
            case 'VYKING_SNEAKER_WINDOW_BUSY_ERROR':
                hideLoader();
                break;
            case 'VYKING_SNEAKER_WINDOW_ERROR':
                hideLoader(true);
                console.error(`${data.requestType} ${data.value}`);
                break;
        }
    }
    async function cameraMessageHandler(event) {
        const { data } = event;
        switch (data.type) {
            case 'VYKING_SNEAKER_WINDOW_WAITING_FOR_CONFIG':
                const config = await loadConfig;
                postConfig(config, window.innerWidth, window.innerHeight);
                break;
            case 'VYKING_SNEAKER_WINDOW_EXPIRY_TIME':
                console.info(`Licence expiry date: ${data.expiryTime.toString()}`);
                if (data.expiryTime.getTime() - new Date().getTime() < 1 * 24 * 60 * 60 * 1000) {
                    console.error(`Expired on ${data.expiryTime.toString()}`);
                    // fetch(configUri, {
                    //   method: 'GET',
                    //   cache: 'reload',
                    // });
                }
                break;
            case 'VYKING_SNEAKER_WINDOW_READY':
                replaceAccessories(selectedAccessories);
                break;
            case 'VYKING_SNEAKER_WINDOW_REPLACE_ACCESSORIES':
                if (data.complete === 1) {
                    hideLoader();
                }
                break;
            case 'VYKING_SNEAKER_WINDOW_BUSY_ERROR':
                hideLoader();
                break;
            case 'VYKING_SNEAKER_WINDOW_ERROR':
                hideLoader(true);
                console.error(`${data.requestType} ${data.value}`);
                break;
        }
    }
    function main() {
        const targetUri = targetOrigin + targetPath;
        window.onmessage = null;
        if (pictureIframe) {
            window.onmessage = (e) => {
                pictureMessageHandler(e);
            };
        }
        if (cameraIframe) {
            window.onblur = () => {
                pause();
            };
            window.onfocus = () => {
                play();
            };
            // replaceAccessories(selectedAccessories);
            // on ready
            window.onmessage = (e) => {
                if (e.data.type) {
                    console.info('message from camera iframe: ', e.data.type);
                }
                cameraMessageHandler(e);
            };
        }
        iframe.src = encodeURI(targetUri);
    }
    // Safari doesn't reload the page when navigating to it and its in the bfcache, so instead
    // we explicitly reload the page to force the camera to be reactivated.
    try {
        window.onmessage = null;
        showLoader();
        main();
    }
    catch (e) {
        console.error(e);
        hideLoader(true);
    }
}
function play() {
    const iframe = document.getElementById('vyking-sneaker-window');
    iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow.postMessage({
        type: 'VYKING_SNEAKER_WINDOW_PLAY',
    }, targetOrigin);
}
function pause() {
    const iframe = document.getElementById('vyking-sneaker-window');
    iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow.postMessage({
        type: 'VYKING_SNEAKER_WINDOW_PAUSE',
    }, targetOrigin);
}
async function getConfig(uri) {
    const response = await fetch(encodeURI(uri));
    if (!response.ok) {
        throw new Error(`Failed to load configuration from ${uri}. Status: ${response.status}`);
    }
    return response.arrayBuffer();
}
export { getConfig, initializeVykingAR, pause, play };
